import bethTullisHeadshot from "../assets/img/Beth Tullis Headshot.jpg";
import kalispellBanner from "../assets/banner/Kalispell MT.jpeg";

export const branchMemberTemplate = {
  firstName: "",
  lastName: "",
  headshot: "",
  account: "",
  title: "",
  nmlsNumber: "",
  mloPage: true,
};

export const nwMontanaBranchData = {
  id: "a2A4M000002aiLMUAY",
  name: "Northwest Montana",
  nameUrl: "nw-montana",
  telephoneNumber: "",
  localCallNumber: "",
  aboutProfile: {
    firstName: "Beth",
    lastName: "Tullis",
    title: "Branch Manager",
    headshot: bethTullisHeadshot,
  },
  description: `
    <h2>Meet Beth Tullis</h2>
    <p>As Branch Manager of the Northwest Montana branch of OneTrust Home Loans, proudly serving the Flathead Valley, I am dedicated to helping clients achieve their homeownership goals with confidence. With extensive experience in residential lending, I bring a personalized approach to every loan, ensuring each client receives a financing solution that supports both their immediate needs and long term financial plans.</p>
    <p>I specialize in FHA, VA, Conventional, Jumbo, Construction, and niche loan programs, guiding clients through the mortgage process with clear communication and trusted advice. I also work closely with local builders, providing financing strategies such as forward commitments and buyer incentive structures that help them sell more homes and keep projects moving.</p>
    <p>Outside of work, my husband and I own a 17-acre hobby farm in Northwest Montana where we raise Arabian horses and enjoy spending time outdoors. We cherish time with our four grandchildren and fully embrace the Montana lifestyle we are proud to call home.</p>
  `,
  photoUrl: kalispellBanner,
  sectionImageUrl: "",
  address: "",
  googleAddress: "",
  coordinates: {
    lat: "",
    lng: "",
  },
  owner: {
    account: "",
  },
  members: [],
};
